/* Weekly specials: the markdown grid sorts by saving, filters by kind and
   caps itself on the phone until Show all. Cart adds, rails and the video
   player come from ca-species.js and ca-hp.js. */
(function () {
  'use strict';
  if (window.__caDeals) return;
  window.__caDeals = true;
  document.querySelectorAll('[data-ca-deals]').forEach(function (root) {
    var grid = root.querySelector('[data-ca-deals-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ca-deals-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ca-deals-tab]'));
    var more = root.querySelector('[data-ca-deals-more]');
    var count = root.querySelector('[data-ca-deals-count]');
    var cap = parseInt(root.getAttribute('data-ca-deals-cap') || '6', 10);
    var tab = 'all';
    var showAll = false;
    cards.sort(function (a, b) { return Number(b.getAttribute('data-ca-save')) - Number(a.getAttribute('data-ca-save')); });
    cards.forEach(function (c) { grid.appendChild(c); });
    function phone() { return window.matchMedia('(max-width: 768px)').matches; }
    function show() {
      var matching = cards.filter(function (c) { return tab === 'all' || c.getAttribute('data-ca-kind') === tab; });
      var limit = (phone() && !showAll) ? cap : matching.length;
      var i = 0;
      cards.forEach(function (c) {
        var on = matching.indexOf(c) >= 0 && i < limit;
        if (matching.indexOf(c) >= 0) i += 1;
        c.hidden = !on;
      });
      if (count) count.textContent = matching.length + (matching.length === 1 ? ' item' : ' items');
      if (more) {
        var hidden = matching.length - Math.min(limit, matching.length);
        more.hidden = hidden <= 0;
        more.textContent = 'Show all ' + matching.length;
      }
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        tab = chip.getAttribute('data-ca-deals-tab');
        showAll = false;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        show();
      });
    });
    if (more) more.addEventListener('click', function () { showAll = true; show(); });
    window.addEventListener('resize', show);
    show();
  });
})();
